module.exports = __webpack_public_path__ + "static/media/Aug3-17.871788d2.png";